<template>
  <div>
    <title-row
      :breadcrumb-items="[
        { text: 'Munkaidő nyilvántartás', disabled: true },
      ]"
      :title="'Munkaidő nyilvántartás'" />

    <v-expansion-panels class="mb-4" :value="0" flat>
      <v-expansion-panel class="rounded-xl">
        <v-expansion-panel-header>
          <span>
            <v-icon left>mdi-filter</v-icon>
            Szűrés
          </span>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row>
            <v-col cols="4">
              <v-select
                @input="fetchWorkers"
                id="query.group"
                v-model="query.group"
                label="Válasszon csoportot"
                :items="groups"
                item-text="label"
                item-value="value" />
            </v-col>

            <v-col v-if="workers.length" cols="4">
              <v-select
                id="query.worker"
                v-model="query.worker"
                label="Válasszon munkavállalót"
                :items="workers"
                item-text="label"
                item-value="value" />
            </v-col>

            <v-col v-if="workers.length" cols="2">
              <v-select
                label="Év"
                v-model="query.year"
                :items="select.years"
                item-text="label"
                item-value="value" />
            </v-col>

            <v-col v-if="workers.length" cols="2">
              <v-select
                label="Hónap"
                v-model="query.month"
                :items="select.months"
                item-text="label"
                item-value="value" />
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <v-card v-if="days.length" flat class="mb-4 rounded-xl">
      <v-card-title>Jelenlét</v-card-title>
      <v-data-table
        :headers="headers"
        :items="days"
        :items-per-page="-1"
        class="elevation-1">
        <template v-slot:item.index="{ index }">
          {{ index + 1 }}
        </template>

        <template v-slot:item.first_enter="{ item }">
          {{ item.first_enter ? trimDate(item.first_enter) : '-' }}
        </template>

        <template v-slot:item.last_leave="{ item }">
          {{ item.last_leave ? trimDate(item.last_leave) : '-' }}
        </template>

        <template v-slot:item.events="{ item }">
          <div v-for="(event, j) in item.events" :key="j">
            <span class="green--text">BE:</span> {{ trimDate(event.enter) }} |
            <span class="red--text">KI:</span> {{ event.leave ? trimDate(event.leave) : '-' }}
            <br v-if="j < item.events.length - 1" />
          </div>
        </template>

        <template v-slot:footer.prepend>
          <v-row no-gutters>
            <v-col class="font-weight-bold">Összesen:</v-col>
            <v-col class="font-weight-bold">{{ month.spent_min }} perc</v-col>
            <v-col class="font-weight-bold">{{ month.spent_hour }} óra</v-col>
          </v-row>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import { years, months, headers } from '../../utils/workTimeHelper.js';
export default {
  name: 'WorkTimeRecord',
  data() {
    return {
      query: {
        group: 0,
        worker: 0,
        year: 0,
        month: 0,
      },
      headers,
      select: {
        years,
        months,
      },
      days: [],
      month: [],
      groups: [],
      workers: [],
    };
  },

  mounted() {
    this.fetchGroups();
  },

  watch: {
    query: {
      handler() {
        if (this.query.group && this.query.worker && this.query.year && this.query.month) {
          this.fetchWorkTimeRecords();
        }
      },
      deep: true,
    },
  },

  methods: {
    trimDate(data) {
      var tmp = data.split(' ');
      return tmp[1];
    },

    async fetchGroups() {
      try {
        const response = await this.$http.get('/work-time/groups');
        this.groups = response.groups;
      } catch (error) {
        console.log('Error fetching groups:', error);
      }
    },

    async fetchWorkers() {
      try {
        const response = await this.$http.get(`/work-time/workers/${this.query.group}`);
        this.workers = response.workers;
      } catch (error) {
        console.log('Error fetching workers:', error);
      }
    },

    async fetchWorkTimeRecords() {
      try {
        const response = await this.$http.post(`/work-time/list`, this.query);
        this.days = response.day_datas;
        this.month = response.month_datas;
      } catch (error) {
        console.log('Error fetching work time records:', error);
      }
    },
  },
};
</script>
